import Signal, { s_invoke } from "badmfck-signal";
import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { UsersService } from "./services/UsersService.ts";
import { AccountsService } from "./services/AccountsService.ts";
import HTTP from "./services/HTTP.ts";
import { Projects } from "./services/Projects.ts";
import { AgentsService } from "./services/AgentsService.ts";
import { CardsService } from "./services/CardsService.ts";
import { KycService } from "./services/KycService.ts";
import { PaymentsService } from "./services/PaymentsService.ts";
import { PayoutsService } from "./services/PayoutsService.ts";
import { AuthService } from "./services/AuthService.ts";
import { CampaignsService } from "./services/CampaignsService.ts";
import Config from "./Config.ts";
import { CardHoldersService } from "./services/CardHolderService.ts";
import { CryptoService } from "./services/CryptoService.ts";
import { CompanyService } from "./services/CompanyService.ts";
import { CompanyTransactionsService } from "./services/CompanyTransactionsService.ts";
import { TeamsService } from "./services/TeamsService.ts";
import { refreshOnNewVersion } from "src/utils/appVersion";

Signal.setupReact(useState, useEffect);

// Initialize MSW if in dev mode and mock mode is enabled
async function enableMocking() {
	if (!import.meta.env.DEV || !Config.MOCK_MODE) {
		return;
	}

	const { worker } = await import("./mocks/browser");

	return worker.start({
		onUnhandledRequest: "bypass",
	});
}

if (import.meta.env.DEV && new URLSearchParams(window.location.search).get("design-preview") === "auth") {
	void import("./design-preview/AuthPreview").then(({ mountAuthPreview }) => mountAuthPreview());
} else if (import.meta.env.DEV && ["private", "company"].includes(new URLSearchParams(window.location.search).get("design-preview") || "")) {
	void import("./design-preview/PrivatePreview").then(({ mountPrivatePreview }) => mountPrivatePreview());
} else enableMocking().then(async () => {
	const hasTriggeredRefresh = await refreshOnNewVersion();
	if (hasTriggeredRefresh) {
		return;
	}

	initializeApp();
});

function initializeApp() {
	window.addEventListener("resize", () => {
		s_invoke({ with: window.innerWidth, height: window.innerHeight }, "resize");
	});

	new AuthService();
	new Projects();
	new HTTP();
	new UsersService();
	new AccountsService();
	new AgentsService();
	new CardHoldersService();
	new CryptoService();
	new CardsService();
	new KycService();
	new CampaignsService();
	new CompanyService();
	new CompanyTransactionsService();
	new PaymentsService();
	new PayoutsService();
	new TeamsService();

	// test
	setTimeout(() => {
		//GD.S_CLIENT_EDITOR.invoke();
	}, 1000);

	createRoot(document.getElementById("root")!).render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}
